export default __webpack_public_path__ + "static/mobile_3-e3403b57baf589b4e9334891a28b16c7.webp";